module.exports = __webpack_public_path__ + "img/APSicon1.19ebddf4.png";